(function(){
	angular.module('cvsApp').directive('storedetailreview',function(){
		return{
			restrict:'E',
			templateUrl: '../storelocator/app/components/storedetail-review/storedetailreview.html',
			controller: ['$scope', '$rootScope' ,'$state', 'checkStoreopen', '$q', '$window',
                'checkFavoriteStore', 'manageFavoriteStoresService', '$stateParams', 'getStoreLocationService', '$cookies', 'cvsAppData','validation',function($scope,$rootScope, $state, $checkStoreopen, $q, $window, CFS, MFS, $stateParams, GSLS, $cookies, CAD, VF) {
                $scope.SDC = this;

                /*angular.element("#specialtySpinner").show();
                angular.element("#loader").show();*/

                $scope.SDC.storeNumber = $stateParams.storeNumber;
                    $scope.SDC.reviewStore = CAD.getReviewOrder();
                    // $scope.$watch(function($rootScope) {
                    //         return $rootScope.showStoreDetailsItem
                    //     },
                    //     function() {
                    //         $scope.SDC.store = $rootScope.showStoreDetailsItem;
                    //         $scope.SDC.setStoreDetailsTiming($scope.SDC.store);
                    //         // viewDetails();
                    //     });
                var tokenID, tokenType;
                tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';
                var storeName = true;
                var storeNumber = $scope.SDC.storeNumber,
                    lati = '',
                    longi = '';
                var storeDetails = {
                    apiKey: cvsUtility.queryMap.apikey,
                    address: storeName ? $scope.SDC.storeName : "",
                    storeNumber: storeNumber ? $scope.SDC.storeNumber : "",
                    iPAddress: "",
                    latitude: lati ? lati : "",
                    longitude: longi ? longi : "",
                    radius: 10,
                    maxResults:100,
                    tokenID: tokenID,
                    tokenType: tokenType,
                    driveThru: "N",
                    store24HR: "N",
                    carePlus: "N",
                    immunization: $scope.SDC.immunization ? 'Y' : 'N',
                    minuteClinic: $scope.SDC.minuteclinic ? 'Y' : 'N',
                    pharmacy24HR: $scope.SDC.Pharmacy24hr ? 'Y' : 'N'
                    // token: cvsUtility.queryMap.token
                    //timeStamp: cvsUtility.queryMap.timeStamp ? cvsUtility.queryMap.timeStamp : (cvsUtility.queryMap.timestamp ? cvsUtility.queryMap.timestamp : '')
                };

                $scope.SDC.tokenID = tokenID;
                // GSLS.getStoreLocation(storeDetails, storeSuccess, 'PZN');
            //    set focus on modal title
                let setFocus = document.getElementById('store-title1');
                if(setFocus){
                 setFocus.focus();
                }
                    

                function storeSuccess(data) {
                    $scope.SDC.store = data.apiResponse.storeDetails.entry.length > 0 ? data.apiResponse.storeDetails.entry[0] : data.apiResponse.storeDetails.entry; // To do need to change the entry[0] as for now we are using mock service we are using this
                    $scope.SDC.setStoreDetailsTiming($scope.SDC.store);
                    $window.localStorage['recentlyViewedStore'] = angular.toJson($scope.SDC.store);
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                }

                //$scope.SDC.favid = CFS.favouriteStoreId;
                $scope.SDC.favCookieStore = $cookies.get('favCookieStore');
                $scope.SDC.storeHourstext = [];
                $scope.SDC.promises = [];
                $scope.SDC.day = '';
                $scope.SDC.storeHours = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                $scope.SDC.hoursStore=
                {
                    "Sun":"Sunday",
                    "Mon": "Monday",
                    "Tue" : "Tuesday",
                    "Wed": "Wednesday",
                    "Thu":"Thursday",
                    "Fri":"Friday",
                    "Sat":"Saturday"
                 }
                    $scope.SDC.checkOpen = function(item, pharOrStore) {
                        if(item){
                            var openStatus = $rootScope.checkOpen(item, pharOrStore);
                            if (openStatus) {
                                return true;
                              } else {
                                return false;
                            }
                        }
                };
                $scope.SDC.showDay = function(day) {
                    var today = '';
                    if (day === undefined || null) {
                        var date = new Date();
                        today = date.getDay();
                    } else {
                        today = day;
                    }
                    $scope.SDC.day = today;
                    return today;

                };
                $scope.SDC.changeday = function(day) {

                }
                $scope.SDC.checkinFav = function(storeid) {
                    if (!$scope.SDC.tokenID && $scope.SDC.favCookieStore) {
                        var cookesItems = $cookies.get('favCookieStore');
                        for (var i = 0; i < cookesItems.length; i++) {
                            if (cookesItems[i].favCookieStore.storeNumber === storeid) {
                                return true;
                            }
                        }
                    } else if ($scope.SDC.tokenID) {
                        var favStores = CAD.getFavStores();

                        if (favStores.length > 0) {
                            for (var i = 0; i < favStores.length; i++) {
                                if (favStores[i].content.properties.EntityID.__text === storeid) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                }
                $scope.SDC.selectStore = function(item) {
                    var storeId = item.content.properties.EntityID.__text;
                    var lati = item.content.properties.Latitude.__text.replace(/[\n\t\r]+/g,'');
                    var longi = item.content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'');

                    var array = [];
                    if ($scope.SDC.tokenID) {
                        MFS.addFavoriteStore(addressAdded, '', 'addStore', storeId);

                    } else {
                        array = [];
                        array.push({
                            'favCookieStore': {
                                storeNumber: storeId,
                                Latitude: lati,
                                Longitude: longi
                            }
                        });
                        $cookies.put('favCookieStore', array);
                        $scope.SDC.favCookieStore = $cookies.get('favCookieStore');
                    }
                }
                $scope.SDC.getDirection = function(store, storenumber) {
                    var stringifiedStore = JSON.stringify(store);
                    if (cvsUtility.setNativeCheck()) {
                        native.locateStoreInMap(stringifiedStore)
                    }
                    else if(cvsUtility.isMobile()){
                        var popupWindow =  window.open('http://maps.apple.com/?q='+store.content.properties.AddressLine.__text+','+store.content.properties.Locality.__text+','+store.content.properties.AdminDistrict.__text+','+store.content.properties.PostalCode.__text);
                        setTimeout(function(){
                            popupWindow.close();
                        }, 5000);
                    }
                    else {
                        $state.transitionTo('store-direction', {
                            storeNumber: storenumber
                        });
                    }
                }
                $scope.SDC.openTel = function(number) {
                    var origVal = number.replace(/[^\w\s]/gi, '');
                    var str, phone;
                    if (origVal.length === 10) {
                        str = origVal.replace(/(.{3})/g, "$1-");
                        phone = str.slice(0, -2) + str.slice(-1);
                    }
                    if (cvsUtility.setNativeCheck()) {
                        native.openExtUrl('tel:' + phone);
                    } else {
                        $window.open('tel:' + phone)
                    }
                }

                function addressAdded(response) {
                    if(response && (response.SERVER_ERROR || response.getError() !== '')){
                        var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                        WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                        return;
                    }
                    CAD.pushFavStore(item);
                    /*if (data.getError() == '') {
                    console.log('favourite store added successfully');
                    }*/

                }
                var storeId;

                $scope.SDC.deleteStore = function(item) {
                    storeId = item.content.properties.EntityID.__text;
                    if ($scope.SDC.tokenID) {
                        MFS.addFavoriteStore(addressDeleted, '', 'deleteStore', storeId);
                    } else {
                        $cookies.put('favCookieStore', []);
                    }
                }

                function addressDeleted(response) {
                    if(response && (response.SERVER_ERROR || response.getError() !== '')){
                        return;
                    }
                        var favStores = CAD.getFavStores();

                        if (favStores.length > 0) {
                            for (var i = 0; i < favStores.length; i++) {
                                if (favStores[i].content.properties.EntityID.__text === storeId) {
                                    favStores.splice(i, 1);
                                }
                            }
                        }
                        CAD.setFavStores(favStores)
                }

                $scope.SDC.setStoreDetailsTiming = function(store) {
                    angular.forEach($scope.SDC.storeHours, function(val, key) {
                        var deferred = $q.defer();
                        $scope.SDC.storeHourstext.push({
                            store: {},
                            pharmacy: {}
                        });
                        $scope.SDC.storeHourstext[key].store.openTime = {};
                        $scope.SDC.storeHourstext[key].store.closedTime = {};
                        deferred.resolve();
                        $scope.SDC.promises.push(deferred.promise);
                    });
                    $q.all($scope.SDC.promises).then(function() {
                        $scope.SDC.storeHourstext[0].store.openTime = store.content.properties.Fs_Sun_Hours.__text && store.content.properties.Fs_Sun_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[0].store.closedTime = store.content.properties.Fs_Sun_Hours.__text && store.content.properties.Fs_Sun_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[1].store.openTime = store.content.properties.Fs_Mon_Hours.__text && store.content.properties.Fs_Mon_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[1].store.closedTime = store.content.properties.Fs_Mon_Hours.__text && store.content.properties.Fs_Mon_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[2].store.openTime = store.content.properties.Fs_Tues_Hours.__text && store.content.properties.Fs_Tues_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[2].store.closedTime = store.content.properties.Fs_Tues_Hours.__text && store.content.properties.Fs_Tues_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[3].store.openTime = store.content.properties.Fs_Wed_Hours.__text && store.content.properties.Fs_Wed_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[3].store.closedTime = store.content.properties.Fs_Wed_Hours.__text && store.content.properties.Fs_Wed_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[4].store.openTime = store.content.properties.Fs_Thur_Hours.__text && store.content.properties.Fs_Thur_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[4].store.closedTime = store.content.properties.Fs_Thur_Hours.__text && store.content.properties.Fs_Thur_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[5].store.openTime = store.content.properties.Fs_Fri_Hours.__text && store.content.properties.Fs_Fri_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[5].store.closedTime = store.content.properties.Fs_Fri_Hours.__text && store.content.properties.Fs_Fri_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[6].store.openTime = store.content.properties.Fs_Sat_Hours.__text && store.content.properties.Fs_Sat_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[6].store.closedTime = store.content.properties.Fs_Sat_Hours.__text && store.content.properties.Fs_Sat_Hours.__text.split()[1];


                        // pharmacy text
                        $scope.SDC.storeHourstext[0].pharmacy.openTime = store.content.properties.Rx_Sun_Hours.__text && store.content.properties.Rx_Sun_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[0].pharmacy.closedTime = store.content.properties.Rx_Sun_Hours.__text && store.content.properties.Rx_Sun_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[1].pharmacy.openTime = store.content.properties.Rx_Mon_Hours.__text && store.content.properties.Rx_Mon_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[1].pharmacy.closedTime = store.content.properties.Rx_Mon_Hours.__text && store.content.properties.Rx_Mon_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[2].pharmacy.openTime = store.content.properties.Rx_Tues_Hours.__text && store.content.properties.Rx_Tues_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[2].pharmacy.closedTime = store.content.properties.Rx_Tues_Hours.__text && store.content.properties.Rx_Tues_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[3].pharmacy.openTime = store.content.properties.Rx_Wed_Hours.__text && store.content.properties.Rx_Wed_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[3].pharmacy.closedTime = store.content.properties.Rx_Wed_Hours.__text && store.content.properties.Rx_Wed_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[4].pharmacy.openTime = store.content.properties.Rx_Thur_Hours.__text && store.content.properties.Rx_Thur_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[4].pharmacy.closedTime = store.content.properties.Rx_Thur_Hours.__text && store.content.properties.Rx_Thur_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[5].pharmacy.openTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Fri_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[5].pharmacy.closedTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Fri_Hours.__text.split()[1];

                        $scope.SDC.storeHourstext[6].pharmacy.openTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Sat_Hours.__text.split()[0];
                        $scope.SDC.storeHourstext[6].pharmacy.closedTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Sat_Hours.__text.split()[1];

                    })
                };

                    $scope.SDC.selectStoreReviewOrder = function(items){
                        $scope.SDC.selectedStore=$scope.SDC.store;
                        var item = $scope.SDC.selectedStore

                        $scope.SDC.selectAddress=true;
                        var validateAddressResult=VF.validateStorePickUpAddress(items);
                        if(validateAddressResult!==""){
                            $scope.$parent.$resolve.parentScope.selectedStore.selectStore=true;
                            $scope.$parent.$resolve.parentScope.ERROR={"SERVER_ERROR":true,"ERROR_MSG":validateAddressResult};
                            $scope.$parent.$resolve.parentScope.selectedStore.selectedStore=$scope.SDC.selectedStore;
                            $scope.$parent.$resolve.parentScope.pickOrDel="pickup";
                            if($scope.$parent.$resolve.parentScope.selectedStore.selectStore){
                                $scope.$parent.$resolve.parentScope.pickOrDel="delivery";
                                $scope.$parent.$resolve.parentScope.selectedStore.selectStore=true;
                            }
                            //deliveryDetailsScope.closePopUP();
                            // $scope.$parent.$resolve.parentScope.closePopUP()
                            $scope.$close();
                        }else{
                            // console.log(items)
                             item = JSON.parse(JSON.stringify(item));
                            parent.postMessage(item, "*"); 
                            //if(deliveryDetailsScope){
                            $scope.$parent.$resolve.parentScope.selectedStore.selectedStore = $scope.SDC.selectedStore;
                            $scope.$parent.$resolve.parentScope.selectStore = false;
                            $scope.$parent.$resolve.parentScope.pickOrDel = "pickup";
                            $scope.$parent.$resolve.parentScope.closePopUP();
                            $scope.$close();
                            //deliveryDetailsScope.closePopUP();
                            //}
                        }
                    }
                    $scope.SDC.store = $rootScope.showStoreDetailsItem;
                    $scope.SDC.setStoreDetailsTiming($scope.SDC.store);
            }
        ]}
		
	})
})();